import React, { useState } from 'react';
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { IRealEstate } from '../../../../Interfaces/IRealEstate';
import { MortgageRealEstateAddress } from '../Components/MortgageRealEstateAddress';
import { MortgageRealEstateLandRegister } from '../Components/MortgageRealEstateLandRegister';

interface IProps {
  realEstate: IRealEstate;
  setRealEstate: React.Dispatch<React.SetStateAction<IRealEstate>>;
}

export const RealEstate: React.FC<IProps> = ({ realEstate, setRealEstate }) => {
  console.log(realEstate);
  const [existsLandRegisterData, setExistsLandRegisterData] = useState<string>(
    realEstate.Street && realEstate.Street !== ''
      ? 'no'
      : realEstate.LandParcelEntryArray.length > 0
        ? 'yes'
        : ''
  );

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setExistsLandRegisterData(event.target.value);
    if (event.target.value === 'no') {
      setRealEstate({
        ...realEstate,
        LandParcelEntryArray: [],
      });
    } else if (event.target.value === 'yes') {
      setRealEstate({
        ...realEstate,
        City: '',
        Postcode: '',
        Street: '',
        StreetNr: '',
        StreetAdditional: '',
        Latitude: null,
        Longitude: null,
        idPostcode: null,
      });
    }
  };

  return (
    <>
      <Typography variant='h6' mb={2}>
        Geben Sie die Grundbuchdaten Ihres Grundstücks an, das mit der
        Grundschuld belastet ist bzw. werden soll. Falls Ihnen diese Daten nicht
        vorliegen geben Sie bitte die Adresse des Grundstücks ein.
      </Typography>

      <Grid container spacing={2}>
        <Grid item sm={12}>
          <Typography variant='body1'>Liegen Grundbuchdaten vor?</Typography>
        </Grid>
        <Grid item sm={12}>
          <FormControl component='fieldset' size='small'>
            <RadioGroup
              row
              aria-label='property-owned'
              name='property-owned'
              value={existsLandRegisterData}
              onChange={handleToggle}
            >
              <FormControlLabel
                value='yes'
                control={<Radio required size='small' />}
                label='Ja'
              />
              <FormControlLabel
                value='no'
                control={<Radio required size='small' />}
                label='Nein'
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item>
          {existsLandRegisterData === 'no' && (
            <MortgageRealEstateAddress
              currentObject={realEstate}
              setCurrentObject={setRealEstate}
              marginTop={0}
            />
          )}
          {existsLandRegisterData === 'yes' && (
            <MortgageRealEstateLandRegister
              currentObject={realEstate}
              setCurrentObject={setRealEstate}
              marginTop={0}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};
